var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.9375C9.36328 4.9375 6.97266 6.34375 5.63672 8.59375C4.33594 10.8789 4.33594 13.6562 5.63672 15.9062C6.97266 18.1914 9.36328 19.5625 12 19.5625C14.6016 19.5625 16.9922 18.1914 18.3281 15.9062C19.6289 13.6562 19.6289 10.8789 18.3281 8.59375C16.9922 6.34375 14.6016 4.9375 12 4.9375ZM12 21.25C8.76562 21.25 5.8125 19.5625 4.19531 16.75C2.57812 13.9727 2.57812 10.5625 4.19531 7.75C5.8125 4.97266 8.76562 3.25 12 3.25C15.1992 3.25 18.1523 4.97266 19.7695 7.75C21.3867 10.5625 21.3867 13.9727 19.7695 16.75C18.1523 19.5625 15.1992 21.25 12 21.25ZM15.9727 10.5977L11.4727 15.0977C11.1211 15.4492 10.5938 15.4492 10.2773 15.0977L8.02734 12.8477C7.67578 12.5312 7.67578 12.0039 8.02734 11.6875C8.34375 11.3359 8.87109 11.3359 9.22266 11.6875L10.875 13.3398L14.7773 9.4375C15.0938 9.08594 15.6211 9.08594 15.9727 9.4375C16.2891 9.75391 16.2891 10.2812 15.9727 10.5977Z",
    fill: "#B2A5FF",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteGoal);
export default __webpack_public_path__ + "static/media/complete-goal.f0415a2fffd7d87a9707c1114ef6a0f3.svg";
export { ForwardRef as ReactComponent };